import {PushNotification} from '../resources/PushNotification';
import {DomainEvent} from './DomainEvent';

export class PushNotificationSubmitted extends DomainEvent<PushNotification> {}
